"use strict";
import allowedAsPod from "./allowed_as_pod";
import isInvoice from "./is_invoice";
function isMissingPodException(rule) {
  return rule.rule_type === "document_presence" && rule.data != null && rule.data.type === "proofOfDelivery";
}
function isInvoiceException(rule) {
  return rule.rule_type === "duplicate_invoice";
}
function nextPageFunctionForRule(rule) {
  if (isMissingPodException(rule)) {
    return allowedAsPod;
  }
  if (isInvoiceException(rule)) {
    return isInvoice;
  }
  return null;
}
function isClickableException(rule) {
  return !!nextPageFunctionForRule(rule);
}
export { nextPageFunctionForRule, isClickableException };
